//import './alteration-list.scss'

import { ReactiveVue } from "@skinsoft/reactive-vue";
import Component from "vue-class-component";
import AlterationLine, { ALTERATION_EDITED, DELETE_ALTERATION } from '../../drawing-editor-components/alteration-line';
import { get } from 'lodash';
import { Alteration } from "@skinsoft/entity/src/condition-report/condition-report-data-store";

@Component({
    components: {
        sAlterationLine: AlterationLine,
    },
    props: ['alterations'],
    template: require('./alteration-list.html')
})
export default class AlterationList extends ReactiveVue {
    private alterations: Alteration[]

    private DELETE_ALTERATION = DELETE_ALTERATION
    private ALTERATION_EDITED = ALTERATION_EDITED

    private getAlterationKey(index) {
        return get(this.alterations[index], "alterationType.id", new Date().getMilliseconds())
    }
}